import React from "react";
import { useModalPaymentMethodViewHook } from "./hook";

type ContextModalPaymentMethodView = ReturnType<
  typeof useModalPaymentMethodViewHook
>;
export const ModalPaymentMethodViewContext =
  React.createContext<ContextModalPaymentMethodView | null>(null);

export function useContextModalPaymentMethodView() {
  const context = React.useContext(ModalPaymentMethodViewContext);

  if (!context) {
    throw new Error(
      "useContextModalPaymentMethodView must be used within a ContextModalPaymentMethodViewProvider",
    );
  }

  return context;
}
